import { axiosInstance } from './axios-instance';
import * as endpoints from "../constants/api-constants";


class ContactService {
    static postQuestion (payload) {
        return axiosInstance.post(endpoints.sendQuestion , payload).then(resp => resp.data)
    }

    // static qualifyProduct(payload, config){
    //     return axios.post(endpoints.qualifyProduct, payload, config).then(res => res.data)
    // }

    // static commentProduct(payload, config){
    //     return axios.post(endpoints.commentProduct, payload, config).then(res => res.data)
    // }
}

export default ContactService;